import * as gcs from 'firebase/storage';

export default gcs;
